import { ValidateJSModel } from 'forms/shared/types';
import { CitizenshipForeignPassportsModel } from './types';
import { citizenshipForeignPassportsItemValidator } from './validators/item';

const citizenshipForeignPassportsValidator: ValidateJSModel<CitizenshipForeignPassportsModel> = {
  Passports: {
    presence: true,
    branchCollection: {
      validator: citizenshipForeignPassportsItemValidator,
    },
  },
  Comments: {},
  SummaryComments: {}
};

export default citizenshipForeignPassportsValidator;
